import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { IoMdClose } from 'react-icons/io';
import styled from 'styled-components';
import FormInput, { FormInputContainer } from './FormInput';
import { useContext, useState } from 'react';
import { DarkButton } from 'components/style/Global';
import { useCampaignContext } from 'context/CampaignContext';
import { API } from 'aws-amplify';
import { createCampaign, saveUmbrellaCampaigns } from 'graphql/mutations';
import { getBriefTemplate } from 'graphql/queries';
import { CreateCampaignMutation, SaveUmbrellaCampaignsMutation, GetBriefTemplateQuery } from 'API';
import { updateBriefBudgetNumber } from 'methods/updateBriefBudget';
import { useSearchParams } from 'react-router-dom';
import { useClientCode } from 'customHooks/useParameters';
import { useClientContext } from 'context/ClientContext';
import { useLoggingActivity } from 'customHooks/useLogging';
import AuthContext from 'context/AuthContext';
import APIContext from 'context/APIContext';

export const Modal = styled.div`
  position: fixed; /* Stay in place */
  z-index: 40; /* Sit on top */
  padding: 50px 0; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  display: flex;
  justify-content: center;

  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 50px;
  }

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1vw;
  }

  .tagsContainer {
    display: grid;
    grid-column: span 2;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1vw;
  }
`;

type Props = {
  seeModal: any;
  setSeeModal(seeModal: any): any;
};

const AddCampaignModal = (props: Props) => {
  const { reducedClientList } = useCampaignContext();
  const [responseMessage, setResponseMessage] = useState<any>();
  const [searchParams, setSearchParams] = useSearchParams();
  const { activeOrganization } = useClientContext();
  const logActivity = useLoggingActivity();
  const { getEnvironment } = useContext(APIContext);

  const [getID, setID] = useClientCode();

  const [values, setValues] = useState({
    name: '',
    startDate: '',
    endDate: '',
    clientCode: '',
    // budget: "",
    comments: '',
    additionalInfo1: '',
    additionalInfo2: '',
    tags: {},
    campaigns: [],
  });

  // Budget related state
  const [showBudget, setShowBudget] = useState(false);
  const [budgetTemplate, setBudgetTemplate] = useState<any>(null);
  const [budgetValues, setBudgetValues] = useState<{ [key: string]: any }>({});
  const [loadingBudget, setLoadingBudget] = useState(false);

  // Budget options
  const budgetOptions = {
    optionsCurrency: ['DKK', 'SEK', 'NOK', 'EUR', 'USD'],
    optionsType: ['CTC', 'Media net'],
    optionsVat: ['Excluded', 'Included'],
  };

  const [campaignType, setCampaignType] = useState<'STANDARD' | 'BOTH' | 'UMBRELLA'>('BOTH');

  const inputs = [
    {
      id: 1,
      name: 'name',
      type: 'text',
      placeholder: 'Campaign Name',
      label: 'Campaign Name',
      errorMessage: 'Campaign Name is a mandatory field',
      required: true,
      inputType: 'BOTH',
    },
    {
      id: 2,
      name: 'clientCode',
      type: 'dropdown',
      placeholder: 'Client Code',
      label: 'Client Code',
      errorMessage: 'Client Code is a mandatory field',
      required: true,
      inputType: 'BOTH',
    },

    {
      id: 3,
      name: 'startDate',
      type: 'date',
      placeholder: 'Start Date',
      label: 'Start Date',
      required: true,
      errorMessage: 'Start Date is a mandatory field',
      inputType: 'STANDARD',
    },
    {
      id: 4,
      name: 'endDate',
      type: 'date',
      placeholder: 'End Date',
      label: 'End Date',
      required: true,
      errorMessage: 'End Date is a mandatory field',
      inputType: 'STANDARD',
    },
    {
      id: 5,
      name: 'campaigns',
      type: 'dropdown',
      placeholder: 'Campaign List',
      label: 'Campaign List',
      required: true,
      errorMessage: 'Campaign List is a mandatory field',
      inputType: 'UMBRELLA',
    },
    // {
    //     id: 5,
    //     name: "budget",
    //     type: "number",
    //     placeholder: "Briefed Budget",
    //     label: "Briefed Budget",
    //     required: true,
    //     errorMessage: "Campaign Name is a mandatory field"
    // },
    /*     {
                id: 6,
                name: "comments",
                type: "textarea",
                placeholder: "Comments",
                label: "Comments",
                required: false,
                errorMessage: ""
            },
            {
                id: 7,
                name: "additionalInfo1",
                type: "textarea",
                placeholder: "Additional Info 1",
                label: "Additional Info 1",
                required: false,
                errorMessage: ""
            },
            {
                id: 8,
                name: "additionalInfo2",
                type: "textarea",
                placeholder: "Additional Info 2",
                label: "Additional Info 2",
                required: false,
                errorMessage: ""
            }, */
  ];

  const tags = [
    {
      id: 1,
      name: 'tagGroup1',
      label: 'Tag Group 1',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 2,
      name: 'tagGroup2',
      label: 'Tag Group 2',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 3,
      name: 'tagGroup3',
      label: 'Tag Group 3',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 4,
      name: 'tagGroup4',
      label: 'Tag Group 4',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 5,
      name: 'tagGroup5',
      label: 'Tag Group 5',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 6,
      name: 'tagGroup6',
      label: 'Tag Group 6',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 7,
      name: 'tagGroup7',
      label: 'Tag Group 7',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 8,
      name: 'tagGroup8',
      label: 'Tag Group 8',
      options: ['option1', 'option2', 'option3'],
    },
    {
      id: 9,
      name: 'tagGroup9',
      label: 'Tag Group 9',
      options: ['option1', 'option2', 'option3'],
    },
  ];

  const onChange = (e: any) => {
    e.preventDefault();
    if (e.target.name.length === 0) {
      setValues({ ...values, clientCode: e.target.value });
    } else {
      setValues({
        ...values,
        [e.target.name]: /* e.target.name === "budget" ? Number(e.target.value) : */ e.target.value,
      });
    }
  };
  const onChangeCampaigns = (e: any) => {
    setValues({ ...values, campaigns: e });
  };

  const onChangeTag = (e: any, name: string) => {
    const newTags = { ...values.tags, [name]: e.target.value };
    const newValues = { ...values, tags: newTags };
    setValues(newValues);
  };

  // Load budget template and initialize budget section
  const handleAddBudget = async () => {
    setLoadingBudget(true);
    try {
      const response = (await API.graphql({
        query: getBriefTemplate,
        variables: {
          Environment: getEnvironment,
          OrganizationId: activeOrganization?.OrganizationId,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetBriefTemplateQuery };

      const template = response.data?.getBriefTemplate;

      if (template) {
        // Find Budget element from template
        const budgetElement = findBudgetElement(template);

        if (budgetElement) {
          setBudgetTemplate(budgetElement);
          setShowBudget(true);
          // Initialize default values
          setBudgetValues({
            Currency: 'EUR',
            Type: 'CTC',
            Vat: 'Excluded',
          });
        }
      }
    } catch (error) {
      console.error('Error loading budget template:', error);
    } finally {
      setLoadingBudget(false);
    }
  };

  // Find Budget element from brief template
  const findBudgetElement = (template: any) => {
    if (!template) return null;

    // Handle different template structures
    let sections = [];
    if (Array.isArray(template)) {
      sections = template;
    } else if (template.sections && Array.isArray(template.sections)) {
      sections = template.sections;
    } else if (template.briefTemplate && Array.isArray(template.briefTemplate)) {
      sections = template.briefTemplate;
    } else {
      return null;
    }

    for (const section of sections) {
      if (section && section.columns) {
        for (const column of section.columns || []) {
          if (column && column.name === 'Budget') {
            return column;
          }
        }
      }
    }
    return null;
  };

  // Handle budget input changes
  const handleBudgetChange = (fieldName: string, value: any) => {
    setBudgetValues((prev) => ({ ...prev, [fieldName]: value }));
  };

  // Get options for budget fields
  const getOptionsForField = (fieldName: string) => {
    switch (fieldName) {
      case 'Currency':
        return budgetOptions.optionsCurrency;
      case 'Type':
        return budgetOptions.optionsType;
      case 'Vat':
        return budgetOptions.optionsVat;
      default:
        return [];
    }
  };
  async function handleAddCampaign(variablesParams: any) {
    // const variableParamsWithouthCampaigns = {
    //   ...variablesParams,
    //   campaigns: variablesParams.campaigns.map((e: any) => e.value),
    // };
    const variableParamsWithouthCampaignsProperties = Object.keys(variablesParams).filter(
      (e) => e !== 'campaigns' && e !== 'tags',
    );
    const variableParamsWithouthCampaigns = variableParamsWithouthCampaignsProperties.reduce(
      (acc: any, key: string) => {
        acc[key] = variablesParams[key];
        return acc;
      },
      {},
    );

    const clientCountry =
      reducedClientList?.filter((e) => e?.ClientCode === variablesParams.clientCode)[0]?.ClientCountry ??
      activeOrganization?.OrganizationId.split('#')[1];
    try {
      const response = (await API.graphql({
        query: createCampaign,
        variables: { ...variableParamsWithouthCampaigns, clientCountry: clientCountry as string },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: CreateCampaignMutation };

      // If campaign creation successful and budget values exist, update budget
      if (response.data.createCampaign?.status === '200' && showBudget && Object.keys(budgetValues).length > 0) {
        // Extract campaign ID from the message - format "Successfully created campaign with ID 47351"
        const message = response.data.createCampaign?.message || '';
        const campaignIdMatch = message.match(/ID\s+(\d+)/);
        const campaignId = campaignIdMatch ? campaignIdMatch[1] : null;
        if (campaignId) {
          try {
            const updateParams: any = {
              campaignId: Number(campaignId),
              Environment: getEnvironment,
            };

            // Map budget values to API parameters
            Object.entries(budgetValues).forEach(([key, value]) => {
              if (value !== undefined && value !== '') {
                if (key === 'Amount') {
                  updateParams.amount = Number(value);
                } else if (key === 'Currency') {
                  updateParams.currency = value;
                } else if (key === 'Type') {
                  updateParams.brief_type = value;
                } else if (key === 'Vat') {
                  updateParams.vat_info = value === 'Included';
                }
              }
            });

            await updateBriefBudgetNumber(updateParams);
          } catch (budgetError) {
            console.log('Error updating briefed budget:', budgetError);
          }
        }
      }

      setValues({
        name: '',
        startDate: '',
        endDate: '',
        clientCode: '',
        // budget: "",
        comments: '',
        additionalInfo1: '',
        additionalInfo2: '',
        tags: {},
        campaigns: [],
      });
      setBudgetValues({});
      setShowBudget(false);
      setBudgetTemplate(null);
      const message = response.data.createCampaign?.message;
      setResponseMessage(message);
      searchParams.delete('campaignID');
      setSearchParams(searchParams);
      setID('none');
      // fetchCampaigns()
      setTimeout(() => {
        setID(getID);
        // setResponseMessage(undefined)
        // props.setSeeModal(false)
      }, 1500);
    } catch (error) {
      console.log('error adding new campaign', error);
      const message = (error as any).errors[0].message;
      setResponseMessage(`Error adding new campaign: ${message}`);
    }
  }

  async function handleAddUmbrellaCampaign(variablesParams: any) {
    const clientCountry =
      reducedClientList?.filter((e) => e?.ClientCode === variablesParams.clientCode)[0]?.ClientCountry ??
      activeOrganization?.OrganizationId.split('#')[1];
    try {
      const response = (await API.graphql({
        query: saveUmbrellaCampaigns,
        variables: {
          Name: variablesParams.name,
          Client: {
            Code: variablesParams.clientCode,
            Country: clientCountry,
            Organization_id: activeOrganization?.OrganizationId,
          },
          Campaigns: variablesParams.campaigns.map((e: any) => e.value),
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: SaveUmbrellaCampaignsMutation };
      setValues({
        name: '',
        startDate: '',
        endDate: '',
        clientCode: '',
        // budget: "",
        comments: '',
        additionalInfo1: '',
        additionalInfo2: '',
        tags: {},
        campaigns: [],
      });
      const message = response.data?.saveUmbrellaCampaigns?.ID;
      setResponseMessage('Umbrella Campaign Created with ID: ' + message);
      searchParams.delete('campaignID');
      setSearchParams(searchParams);
      setID('none');
      setTimeout(() => {
        setID(getID);
      }, 1500);
    } catch (error) {
      console.log('error adding new campaignsssssss', error);
      const message = (error as any).errors[0].message;
      setResponseMessage(message);
    }
  }

  const handleSubmitClick = async () => {
    // Log the add campaign activity
    logActivity({
      action: 'ADD_CAMPAIGN',
    }).catch(console.error);

    // Call the appropriate add campaign function based on type
    if (campaignType === 'STANDARD') {
      handleAddCampaign(values);
    } else {
      handleAddUmbrellaCampaign(values);
    }
  };

  // HERE
  return (
    <Modal>
      <HeadModul>
        {!responseMessage ? (
          <>
            {' '}
            <button type="button" className="x" onClick={() => props.setSeeModal(false)}>
              {' '}
              <IoMdClose className="closeIcon" />
            </button>
            <ModulContainer>
              <h1>Create Campaign</h1>

              <FormInputContainer>
                <label htmlFor="campaignType">Campaign Type</label>
                <select
                  name=""
                  id="campaignType"
                  onChange={(e) => setCampaignType(e.target.value as 'STANDARD' | 'BOTH' | 'UMBRELLA')}
                >
                  {' '}
                  <option value="BOTH"></option>
                  <option value="STANDARD">Standard</option>
                  {<option value="UMBRELLA">Umbrella</option>}
                </select>
              </FormInputContainer>
              <form>
                {inputs
                  .filter((input) => input.inputType === 'BOTH' || input.inputType === campaignType)
                  .map((input) => (
                    <FormInput
                      key={input.id}
                      {...input}
                      value={values[input.name as keyof typeof values]}
                      onChange={input.name === 'campaigns' ? onChangeCampaigns : onChange}
                      selectedClient={values.clientCode}
                    ></FormInput>
                  ))}

                {/* Budget section for Standard campaigns */}
                {campaignType === 'STANDARD' && !showBudget && (
                  <FormInputContainer
                  // style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column' }}
                  >
                    <label>Do you want to add budget?</label>
                    <button type="button" onClick={handleAddBudget} disabled={loadingBudget}>
                      {loadingBudget ? 'Loading...' : 'Add Budget'}
                    </button>
                  </FormInputContainer>
                )}

                {/* Budget fields using standard two-column layout */}
                {campaignType === 'STANDARD' && showBudget && budgetTemplate?.subColumns && (
                  <>
                    {budgetTemplate.subColumns.map((field: any) => (
                      <div key={field.id}>
                        <FormInputContainer>
                          <label>{field.label}</label>
                          {field.type === 'SELECT' ? (
                            <select
                              value={budgetValues[field.name] || ''}
                              onChange={(e) => handleBudgetChange(field.name, e.target.value)}
                            >
                              <option value=""></option>
                              {getOptionsForField(field.name).map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type={field.type === 'NUMBER' ? 'number' : 'text'}
                              placeholder={field.label}
                              value={budgetValues[field.name] || ''}
                              onChange={(e) => handleBudgetChange(field.name, e.target.value)}
                            />
                          )}
                        </FormInputContainer>
                      </div>
                    ))}
                    <div></div>
                    <button
                      type="button"
                      onClick={() => {
                        setShowBudget(false);
                        setBudgetTemplate(null);
                        setBudgetValues({});
                      }}
                    >
                      Remove Budget
                    </button>
                  </>
                )}

                {/*   <div className="tagsContainer">
                            {tags.map(tag => (
                                <TagInput onChangeTag={onChangeTag} key={tag.id} {...tag}></TagInput>
                            ))}
                        </div> */}
              </form>
              {campaignType !== 'BOTH' && (
                <DarkButton type="button" onClick={() => handleSubmitClick()}>
                  Submit
                </DarkButton>
              )}
            </ModulContainer>{' '}
          </>
        ) : (
          <>
            <button
              type="button"
              className="x"
              onClick={() => {
                props.setSeeModal(false);
                setResponseMessage(undefined);
              }}
            >
              {' '}
              <IoMdClose className="closeIcon" />
            </button>
            <ModulContainer>
              <p>{responseMessage}</p>
            </ModulContainer>
          </>
        )}
      </HeadModul>
    </Modal>
  );
};

export default AddCampaignModal;
